<template>
  <ManageBox class="vehTypeManage">
    <template slot="upside">
      <el-form
        ref="form"
        :model="form"
        label-width="80px"
      >
        <el-form-item>
          <el-col :span="11">
            <el-date-picker
              size="small"
              type="datetime"
              placeholder="开始日期"
              v-model="form.beginTime"
              style="width: 100%;"
              default-time="00:00:00"
            ></el-date-picker>
          </el-col>
          <el-col
            class="line"
            :span="1"
          >-</el-col>
          <el-col :span="11">
            <el-date-picker
              size="small"
              type="datetime"
              placeholder="结束日期"
              v-model="form.endTime"
              style="width: 100%;"
              default-time="00:00:00"
            ></el-date-picker>
          </el-col>
        </el-form-item>
      </el-form>
      <SelectInput
        v-model="searchValue"
        :dbclickFlag="false"
        :showGroup="false"
        style="margin: 20px"
      />
      <el-button
        style="margin-left: 32px"
        size="small"
        type="primary"
        @click="getRealtimeAlarmReport()"
      >查询</el-button>

      <!-- <el-button
        style="margin-left: auto"
        size="small"
        @click="exportNoxReport()"
      >导出</el-button> -->
    </template>

    <div
      class="vehTypeManage__content"
      slot="content"
    >
      <!-- 表格开始 -->
      <!-- :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)" -->
      <el-table
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 1)"
        height="100%"
        max-height="100%"
        :data="tableData"
        border
        stripe
        style="min-width: 100%"
        row-key="index"
        size="mini"
        ref="table">
        <el-table-column
          fixed
          prop="index"
          label="序号"
          width="50"
          align="center"
        />
        <el-table-column
          prop="bmsNo"
          label="电池编号"
          min-width="100"
          align="center"
        />

        <el-table-column
          prop="bmsType"
          label="电池类型"
          align="center"
          min-width="180"
        />

        <!-- <el-table-column
          prop="groupId"
          label="组织id"
          align="center"
          min-width="180"
        /> -->

        <el-table-column
          prop="groupName"
          label="组织名称"
          align="center"
          min-width="180"
        />

        <el-table-column
          prop="terminalType"
          label="终端类型"
          align="center"
          min-width="180"
        />

        <el-table-column
          prop="vehicleId"
          label="终端ID"
          align="center"
          min-width="180"
        />
        <el-table-column
          property="a"
          label="电流(A)"
          min-width="100"
          align="center"
        ></el-table-column>

        <el-table-column
          property="d"
          label="SOC电量"
          min-width="150"
          align="center"
        ></el-table-column>

        <el-table-column
          property="t"
          label="终端时间"
          min-width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          property="v"
          label="总电压"
          min-width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          property="w"
          label="工作状态"
          min-width="180"
          align="center"
        ></el-table-column>

        <el-table-column
          fixed="right"
          label="电池详情"
          min-width="80"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="getAll(scope.row)"
            >查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 表格结束 -->

      <!-- 分页开始 -->
      <el-pagination
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :page-sizes="[20, 50, 100]"
        @size-change="getRealtimeAlarmReport"
        @current-change="currentChange"
        layout="total,sizes, prev, pager, next, jumper"
        :total="total"
      />
      <!-- 分页结束 -->
    </div>
    <div slot="plugins">
      <Dialog
        :visible.sync="batteryVisible"
        :batteryData.sync="batteryData"
        :type.sync="batteryType"
      />
    </div>
  </ManageBox>
</template>

<script>
import day from "dayjs";
import ManageBox from "@/components/ManageBox/index.vue";
import SelectInput from "@/components/SelectInput/index.vue";
import Dialog from "@/components/BatteryDataDialog/index.vue";
import { mapState } from 'vuex';

export default {
  components: {
    ManageBox,
    SelectInput,
    Dialog
  },
  data() {
    return {
      selectMonitorInfo:null,
      batteryVisible: false,
      batteryData: {},
      batteryType: "",
      terminalType: "",
      loading: false,
      dialogData: null,
      detailDialog: false,
      form: {
        beginTime: day(day(new Date()).subtract(7, "day")).format(
          "YYYY-MM-DD 00:00:00:0"
        ),
        endTime: day(new Date()).format("YYYY-MM-DD 23:59:59:0"),
        dayBeginTime: day(day(new Date()).subtract(7, "day")).format(
          "YYYY-MM-DD 00:00:00:0"
        )
      },
      searchValue: null,
      currentPage: 1,
      pageSize: 100,
      tableData: [],
      getParams: {},
      total: 0
    };
  },
  computed:{
      ...mapState(['USER']),
  },
  mounted() {
    //监听表格滚动
    const dom = this.$refs.table.bodyWrapper;
    dom.addEventListener("scroll", () => {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    });
  },

  methods: {
    //获取电池所有信息
    async getAll(data) {
        this.batteryType = data.terminalType.split("-")[1];
        if(data.terminalType == 'GPRS-DALI' || data.terminalType == "GPRS-HERCULES" || data.terminalType == "LD-01A" || data.terminalType == "GPRS-SUNWODA"){
            let self = this;
            await this.$API.getBmsTrackDetail({
                time:data.t,
                vehicleId: data.vehicleId
            }).then(res=>{
                this.selectMonitorInfo = res.data;
                let Data = {
                    alarm:{},
                    analog:{}
                }
                function generateName(o,name){
                    let obj = [];
                    for(let item in self.selectMonitorInfo[o]){
                        obj.push({title:item,value:self.selectMonitorInfo[o][item]});
                    }
                    return obj;
                }
                //告警量
                Data.alarm.errorStatus = generateName('errorStatus','alarm.errorStatus');
                Data.alarm.protectStatus = generateName('protectStatus','alarm.protectStatus');
                Data.alarm.systemStatus = generateName('systemStatus','alarm.systemStatus');
                Data.alarm.warnStatus = generateName('warnStatus','alarm.warnStatus');
                Data.baseInfo = generateName('baseInfo','alarm.baseInfo');
                console.log(this.selectMonitorInfo)
                Data.analog.salveTempList = this.selectMonitorInfo.salveTempList?this.selectMonitorInfo.salveTempList:[];
                //模拟量
                Data.analog.mapList = this.selectMonitorInfo.mapList?this.selectMonitorInfo.mapList.map((item)=>{return item.coreVoltage;}):[];
                Data.analog.tempList = this.selectMonitorInfo.tempList?this.selectMonitorInfo.tempList:[];
                this.batteryData = Data;
                Data = {alarm:{},analog:{}};
            })
        }else{
            this.batteryData = data.bmsMap;
        }
        this.batteryVisible = true;
    },
    currentChange (val) {
      this.currentPage = val;
      console.log(val)
      this.getRealtimeAlarmReport();
    },
    //获取电池历史数据
    async getRealtimeAlarmReport() {
      let params = {
        beginTime: day(this.form.beginTime || this.form.dayBeginTime).format(
          "YYYY-MM-DD HH:mm:ss:0"
        ),
        endTime: day(this.form.endTime || new Date()).format(
          "YYYY-MM-DD HH:mm:ss:999"
        ),
        pageSize:this.pageSize,
        pageNumber:this.currentPage
      };
      if (
        this.searchValue != null &&
        this.searchValue.hasOwnProperty("vehicleId")
      ) {
        params.vehicleId = this.searchValue.vehicleId;
      }
      if (this.form.beginTime > this.form.endTime) {
        this.$msg({
          showClose: true,
          message: "开始时间不能大于结束时间!",
          type: "error"
        });
        return;
      }
      if (this.searchValue === null) {
        this.$msg({
          showClose: true,
          message: "请选择/输入终端ID",
          type: "error"
        });
        return;
      }
      this.getParams = params;
      try {
        this.loading = true;
        const { data, total } = await this.$API.getBmsTrack(params);
        this.total = total;
        const otherData = {
          bmsNo: data.bmsNo,
          bmsType: data.bmsType,
          groupId: data.groupId,
          groupName: data.groupName,
          terminalType: data.terminalType,
          vehicleId: data.vehicleId
        };

        this.tableData = data.bmsList.map((item, index) => ({
          ...otherData,
          ...item,
          index: (this.currentPage - 1) * this.pageSize + index + 1
        }));
        console.log(this.tableData)
        if (total === 0) {
          this.$msg({
            showClose: true,
            message: "暂无数据",
            type: "success"
          });
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error(error);
        this.$msg({
          showClose: true,
          message: error.msg,
          type: "error"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// ::v-deep .el-pagination {
//   padding-top: 20px;
// }
.vehTypeManage {
  &__content {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #fff;
    padding: 16px;
  }
  &__footer {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #fff;
    padding: 16px;
  }
}
span {
  color: rgb(179, 179, 179);
  margin: 10px;
}
::v-deep .el-form-item {
  margin-bottom: 2px;
}
::v-deep .el-form-item__content {
  margin-left: 0 !important;
  width: 420px;
}
::v-deep .el-col-1 {
  margin-left: 2%;
}
</style>
